import { render, staticRenderFns } from "./cqgmzyjsxy.vue?vue&type=template&id=3bc5ca82&scoped=true&"
import script from "./cqgmzyjsxy.vue?vue&type=script&lang=js&"
export * from "./cqgmzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./cqgmzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cqgmzyjsxy.vue?vue&type=style&index=1&id=3bc5ca82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc5ca82",
  null
  
)

export default component.exports